import { useLocation, useNavigate } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const category = location.pathname.split("/")[2] || "Category";
  const categoryProduct = params.get("category_product") || "";

  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const formattedCategory = capitalizeWords(category);
  const formattedCategoryProduct = capitalizeWords(categoryProduct);

  const breadcrumbItems = [{ label: "Home", path: "/" }];

  breadcrumbItems.push({ label: formattedCategory, path: location.pathname });

  if (categoryProduct && formattedCategory !== formattedCategoryProduct && !categoryProduct.includes("_")) {
    breadcrumbItems.push({ label: formattedCategoryProduct, path: "" });
  }

  return (
    <nav className="text-sm text-gray-600">
      {breadcrumbItems.map((item, index) => (
        <span key={index}>
          {index > 0 && " / "}
          {item.path ? (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => navigate(item.path)}
              className="text-blue-500 hover:underline cursor-pointer"
            >
              {item.label}
            </span>
          ) : (
            <span className="font-bold">{item.label}</span> // Subcategory (Bold & No Link)
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumb;
